import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
import axios from 'axios';
import Date from './filters/date';

import QscDataTable from "@quasiris/qsc-data-table";
import QscEditTable from "@quasiris/qsc-edit-table";

Vue.component('qsc-data-table', QscDataTable);
Vue.component('qsc-data-table', QscEditTable);


const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
    duration: 500,
});

Vue.filter('formatDate', Date);


// eslint-disable-next-line no-undef
axios.defaults.baseURL = globalConfig.api_url;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
